module.exports = __webpack_public_path__ + "img/cover.4d9b1ba3.png";